"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = _interopRequireDefault(require("react"));
var _isFunction = _interopRequireDefault(require("lodash/fp/isFunction"));
var _omit = _interopRequireDefault(require("lodash/fp/omit"));
var _prop = _interopRequireDefault(require("lodash/fp/prop"));
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _map = _interopRequireDefault(require("lodash/fp/map"));
var _LocaleContext = require("@active/react-utils/i18n/LocaleContext");
var _NumberProcessor = require("./NumberProcessor");
var _Input = _interopRequireDefault(require("../Input"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var DECIMAL_EXPRESSION = /^-?(([1-9][0-9]*\.?[0-9]*)|0|(0\.[0-9]*))?$/;
var INVALID_RESULT_EXPRESSION = /^(-|(.*\.))$/;
var INITIAL_STATE = {
  forceUpdateCaret: 0
};
var parseString = function parseString(value) {
  if (value === undefined || value === null) {
    return '';
  }
  if (typeof value !== 'string') {
    return "".concat(value);
  }
  return value;
};
var isDecimal = function isDecimal(value) {
  return DECIMAL_EXPRESSION.test(value);
};
var process = function process(processor) {
  return function (operator) {
    return processor.test(operator.source) ? processor.processNumber(operator) : operator;
  };
};
var processNumericValue = function processNumericValue(processors) {
  return _compose["default"].apply(void 0, (0, _toConsumableArray2["default"])((0, _map["default"])(process)(processors)));
};
var removeStandaloneMinusSign = function removeStandaloneMinusSign(source) {
  return source.replace(/^-$/, '');
};
var removeTrailingPoint = function removeTrailingPoint(source) {
  return source.replace(/\.$/, '');
};
var correctResult = (0, _compose["default"])(removeStandaloneMinusSign, removeTrailingPoint);
var NumericInput = /*#__PURE__*/function (_React$Component) {
  function NumericInput(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, NumericInput);
    _this = _callSuper(this, NumericInput, [props]);
    _this.state = _this.getInitializeState(props);
    _this.caretUpdateCounter = _this.state.forceUpdateCaret;
    _this.handleBlur = _this.handleBlur.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.setInputRef = _this.setInputRef.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(NumericInput, _React$Component);
  return (0, _createClass2["default"])(NumericInput, [{
    key: "getInitializeState",
    value: function getInitializeState(initialProps) {
      return this.isControlled() ? _objectSpread({}, INITIAL_STATE) : _objectSpread(_objectSpread({}, INITIAL_STATE), {}, {
        value: parseString(initialProps.defaultValue)
      });
    }
  }, {
    key: "markCaretPosition",
    value: function markCaretPosition() {
      if (!this.input) {
        return;
      }
      var _this$input = this.input,
        start = _this$input.selectionStart,
        end = _this$input.selectionEnd;
      this.caretPosition = {
        start: start,
        end: end
      };
    }
  }, {
    key: "adjustCaretPosition",
    value: function adjustCaretPosition() {
      if (this.caretPosition && this.input) {
        this.input.setSelectionRange(this.caretPosition.start, this.caretPosition.end);
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      var onBlur = this.props.onBlur;
      var value = this.getValue();
      if (this.isInvalidResult(value)) {
        this.updateValue(correctResult(value));
      }
      if ((0, _isFunction["default"])(onBlur)) {
        onBlur(e);
      }
    }
  }, {
    key: "isInvalidResult",
    value: function isInvalidResult(value) {
      return INVALID_RESULT_EXPRESSION.test(value);
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      var onKeyDown = this.props.onKeyDown;
      this.markCaretPosition();
      if ((0, _isFunction["default"])(onKeyDown)) {
        onKeyDown(e);
      }
    }
  }, {
    key: "toFixedPointProcessor",
    get: function get() {
      return (0, _NumberProcessor.toFixedPoint)(this.props.fixedPoint);
    }
  }, {
    key: "getNumberProcessors",
    value: function getNumberProcessors() {
      return [_NumberProcessor.fillMissedLeadingZero, _NumberProcessor.removeExtraLeadingZero, this.toFixedPointProcessor];
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      var originValue = (0, _prop["default"])('target.value')(event);
      var caret = {
        start: this.input.selectionStart,
        end: this.input.selectionEnd
      };
      var processedValue = processNumericValue(this.getNumberProcessors())({
        source: originValue,
        caret: caret
      });
      if (isDecimal(processedValue.source)) {
        var _processedValue$caret;
        this.updateValue(processedValue.source);
        if (caret.start !== ((_processedValue$caret = processedValue.caret) === null || _processedValue$caret === void 0 ? void 0 : _processedValue$caret.start) || caret.end !== processedValue.caret.end) {
          this.caretPosition = processedValue.caret;
          this.forceUpdateCaret();
        }
      } else {
        this.forceUpdateCaret();
      }
    }
  }, {
    key: "forceUpdateCaret",
    value: function forceUpdateCaret() {
      this.setState({
        forceUpdateCaret: this.state.forceUpdateCaret + 1
      });
    }
  }, {
    key: "isControlled",
    value: function isControlled() {
      var _this$props = this.props,
        value = _this$props.value,
        onChange = _this$props.onChange;
      return value !== undefined && (0, _isFunction["default"])(onChange);
    }
  }, {
    key: "updateValue",
    value: function updateValue(value) {
      var onChange = this.props.onChange;
      if (this.isControlled()) {
        onChange === null || onChange === void 0 || onChange(value);
      } else {
        this.setState({
          value: value
        });
      }
    }
  }, {
    key: "registerValidateIfNeed",
    value: function registerValidateIfNeed() {
      var _this2 = this;
      var valiatorRegister = this.valiatorRegister;
      var registerValidate = this.props.registerValidate;
      if (registerValidate !== valiatorRegister) {
        this.valiatorRegister = registerValidate;
        if ((0, _isFunction["default"])(registerValidate)) {
          registerValidate(function (value) {
            var _this2$props = _this2.props,
              min = _this2$props.min,
              max = _this2$props.max,
              i18n = _this2$props.i18n,
              nonNegative = _this2$props.nonNegative;
            // Has potential to exceed the maximum float or integer.
            var num = isDecimal(value) ? parseFloat(value) : parseInt(value, 10);
            if (nonNegative) {
              if (num < 0) {
                return i18n('react-ui.validation.none.negative');
              }
            }
            if (min !== null && min !== undefined) {
              if (num < min) {
                return i18n('react-ui.validation.min', {
                  min: min.toString()
                });
              }
            }
            if (max !== null && max !== undefined) {
              if (num > max) {
                return i18n('react-ui.validation.max', {
                  max: max.toString()
                });
              }
            }
            return undefined;
          });
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.registerValidateIfNeed();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.registerValidateIfNeed();
      if (this.needToUpdateCaret()) {
        this.adjustCaretPosition();
        this.caretUpdateCounter = this.state.forceUpdateCaret;
      }
    }
  }, {
    key: "needToUpdateCaret",
    value: function needToUpdateCaret() {
      var forceUpdateCaret = this.state.forceUpdateCaret;
      return this.caretUpdateCounter !== forceUpdateCaret;
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.isControlled() ? parseString(this.props.value) : this.state.value;
    }
  }, {
    key: "formatValue",
    value: function formatValue() {
      return this.toFixedPointProcessor.test(this.getValue()) ? this.toFixedPointProcessor.processNumber({
        source: this.getValue(),
        caret: null
      }).source : this.getValue();
    }
  }, {
    key: "setInputRef",
    value: function setInputRef(input) {
      var inputRef = this.props.inputRef;
      this.input = input;
      if ((0, _isFunction["default"])(inputRef)) {
        inputRef(input);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_Input["default"], (0, _extends2["default"])({
        autoComplete: "off",
        "data-testid": "numeric-input"
      }, (0, _omit["default"])(['i18n', 'onTouched', 'defaultValue', 'inputRef', 'fixedPoint', 'nonNegative'])(this.props), {
        ref: this.setInputRef,
        value: this.formatValue(),
        inputMode: "decimal",
        type: "text",
        onKeyDown: this.handleKeyDown,
        onChange: this.handleChange,
        onBlur: this.handleBlur
      }));
    }
  }]);
}(_react["default"].Component);
var _NumericInput = (0, _LocaleContext.withI18n)(NumericInput);
_NumericInput.displayName = 'NumericInput';
var _default = exports["default"] = _NumericInput;